import type { CSSProperties, ComponentType, ReactNode } from "react";

// Shim for antd's generic <Icon component={...} /> (custom icon renderer).
// Renders the provided component; children/style passed through.
export interface IconProps {
  component?: ComponentType<Record<string, unknown>>;
  className?: string;
  style?: CSSProperties;
  onClick?: () => void;
  children?: ReactNode;
}

export const Icon = ({ component: Component, className, style, onClick, children }: IconProps) => (
  <span className={className} style={style} onClick={onClick}>
    {Component ? <Component /> : children}
  </span>
);

export default Icon;
